import { connect } from 'react-redux'
import { ICoordinates, IStoreState } from '../../types'
import LiveDriversPane from '../../components/drivers/LiveDriversPane'
import { getProductOperators, getDriversList, getOrgOperators } from '../../state/actions/drivers'
import { actionCreators } from '../../state/actions/google_map'
import * as serviceActions from '../../state/actions/services'
import { IMarker } from '../../types'
import { RouteComponentProps } from 'react-router-dom'

export function mapStateToProps(state: IStoreState) {
  const currentService = state.trips.filters.serviceId ? state.service.items[state.trips.filters.serviceId] : null
  return {
    operators: Object.values(state.drivers.items),
    operatorPings: state.drivers.liveOperators,
    currentOrganizationId: state.organizations.currentOrgId,
    products: state.providerProduct.items,
    currentServiceId: state.trips.filters.serviceId,
    currentService,
    tripFilters: state.trips.filters
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    addDriversToMap: (driverMarkers: IMarker[]) => dispatch(actionCreators.replaceMarkers('car', driverMarkers)),
    clearMap: () => dispatch(actionCreators.clearMarkers('car')),
    getOperators: (organizationId: string, serviceIds?: string[]) => {
      return dispatch(
        getDriversList({
          organizationId,
          skip: 0,
          take: 1000,
          serviceIds
        })
      )
    },
    setCurrentTripStage: (stage: string) => dispatch(actionCreators.setMapViewStrategyStage(stage)),
    getOrgOperators: (orgId: string) => dispatch(getOrgOperators(orgId)),
    getService: (serviceId: string) => dispatch(serviceActions.fetchService(serviceId)),
    locateDriver: (coordinates: ICoordinates) => {
      dispatch(actionCreators.setOrigin(coordinates)),
        dispatch(actionCreators.setDestination(coordinates)),
        dispatch(
          actionCreators.replaceMarkers('origin', [{ type: 'origin', lat: coordinates.lat, lng: coordinates.lng }])
        )
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveDriversPane)



// WEBPACK FOOTER //
// ./src/containers/drivers/LiveDriversPane.ts